﻿

/*------------------------------------*\
    #URL
\*------------------------------------*/


window.gro = window.gro || {};
gro.modules = gro.modules || {};


gro.modules.subcustomers = (function () {
    var priv = {};

    /**
     * Private initialization method
     */
    priv.init = function () {

        //Sort table
        var sortSubcustomerTable = $(".tablesaw-sortable-btn").on("click", function () {

            if ($(this).parent().hasClass("tablesaw-sortable-ascending") === true) {
                $("#sort-index-subcustomer").data("page-SortOrder", "desc");
            }
            else if ($(this).parent().hasClass("tablesaw-sortable-descending") === true) {
                $("#sort-index-subcustomer").data("page-SortOrder", "asc");
            }

            if ($(this).parent().data("tablesaw-priority") === 2) {
                $("#sort-index-subcustomer").data("value", "IsActive");
            }
            else if ($(this).parent().data("tablesaw-priority") === 1)
                $("#sort-index-subcustomer").data("value", "CustomerNr");
            else if ($(this).parent().data("tablesaw-priority") === "persist")
                $("#sort-index-subcustomer").data("value", "CustomerName");

            var _sortIndex = $("#sort-index-subcustomer").data("value");
            var _sortOrder = $("#sort-index-subcustomer").data("page-SortOrder");
            $.ajax({
                url: "/api/subcustomer/sort-subcustomer",
                datatype: 'json',
                type: "POST",
                data: {
                    sortIndex: _sortIndex,
                    pageIndex: 0,
                    sortOrder: _sortOrder
                },
                success: function (data) {
                    $("#subcustomer-table-fill-body").empty();

                    for (var i = 0; i < data.SubCustomer.length; i++) {
                        var active = data.SubCustomer[i].IsActiveSubCustomer === true ? "active" : "";
                        var aktiverad = data.SubCustomer[i].IsActiveSubCustomer === true ? "Aktiverad" : "Inaktiv";
                        $("#subcustomer-table-fill-body").append('<tr><td class ="u-ellipsis">' + data.SubCustomer[i].OrganisationName +
                            '</td><td class = "tablesaw-priority1">' + data.SubCustomer[i].CustomerNo + '</td><td class = "tablesaw-priority2"><span class="subcustomers__status ' + active + '">' + aktiverad + '</span ><button id="subcustomer-button" class="lm__inline-edit-btn  margin-left-15  js-handle-subcustomer" data-customerid="' + data.SubCustomer[i].CustomerNo + '" type="button"></button></td></tr>')
                    }
                    authSubcustomerButton();
                    $(".subcustomers-page-item").removeClass("active");
                    $('.subcustomers-page-index[data-value="0"]').parent().addClass('active');
                }

            })

        });


    };

    //Authorize subcustomter
    var authSubcustomerButton = function () {
        $(".js-handle-subcustomer").on("click", function () {

            var customerId = $(this).data("customerid");
            var customerStatus = $(this).prev(".subcustomers__status");
            var isActive = customerStatus.hasClass("active");
            var dialog = isActive ? "#deactivate-subcustomer-modal" : "#activate-subcustomer-modal";
            dialog = $(dialog);

            // Show dialog
            dialog.fadeIn();

            // Cancel button
            $(".cancel", dialog).off().click(function () {
                dialog.fadeOut();
            });

            // Confirm button
            $(".confirm", dialog).off().click(function () {
                dialog.fadeOut();
                authorizeSubcustomer(isActive, customerId, customerStatus);

            });

        })
    };
    //Authenticate subcustomers
    var authorizeSubcustomer = function (isActive, customerId, customerStatus) {
        if (isActive === true) {
            isActive = false;
        }
        else {
            isActive = true;
        }

        $.ajax({
            url: "/api/subcustomer/auth-subcustomer",
            datatype: 'json',
            type: "POST",
            data: {
                subCustomerNumber: customerId,
                isAuthenticated: isActive,
                changeAuth: true
            },
            success: function (data) {
                isActive = isActive === true ? "1" : "0";
                if (data === isActive) {
                    if (isActive === "0") {
                        // Deactivate customer
                        customerStatus.removeClass("active").html("Inaktiv");
                    }
                    else {
                        // Activate customer
                        customerStatus.addClass("active").html("Aktiverad");
                    }
                }
                else {
                    alert("Något gick fel, det gick inte aktivera/inaktivera kunden. Ring caMILLA");
                }

            }

        })
    };

    //Pagination
    var selectPageSubcustomers = function () {
        $(".subcustomers-page-index").on("click", function () {

            var _sortIndex = $("#sort-index-subcustomer").data("value");
            var _sortOrder = $("#sort-index-subcustomer").data("page-SortOrder");
            var _pageIndex = $(this).data("value");

            $("#sort-index-subcustomer").data("page-index", $(this).data("value"));
            $(".subcustomers-page-item").removeClass("active");
            $(this).parent().addClass("active");

            loadPageSubscribers(_sortIndex, _pageIndex, _sortOrder);

            $('html,body').animate({
                scrollTop: $("#subcustomer-scroll").offset().top
            }, 400);
        })
    };
    //loads subcustomers
    var loadPageSubscribers = function (_sortIndex, _pageIndex, _sortOrder) {
        $.ajax({
            url: "/api/subcustomer/sort-subcustomer",
            datatype: 'json',
            type: "POST",
            data: {
                sortIndex: _sortIndex,
                pageIndex: _pageIndex,
                sortOrder: _sortOrder
            },
            success: function (data) {
                $("#subcustomer-table-fill-body").empty();

                for (var i = 0; i < data.SubCustomer.length; i++) {
                    var active = data.SubCustomer[i].IsActiveSubCustomer === true ? "active" : "";

                    var aktiverad = data.SubCustomer[i].IsActiveSubCustomer === true ? "Aktiverad" : "Inaktiv";
                    $("#subcustomer-table-fill-body").append('<tr><td class ="u-ellipsis">' + data.SubCustomer[i].OrganisationName +
                        '</td><td class = "tablesaw-priority1">' + data.SubCustomer[i].CustomerNo + '</td><td class = "tablesaw-priority2"><span class="subcustomers__status ' + active + '">' + aktiverad + '</span ><button id="subcustomer-button" class="lm__inline-edit-btn  margin-left-15  js-handle-subcustomer" data-customerid="' + data.SubCustomer[i].CustomerNo + '" type="button"></button></td></tr>')
                }
                authSubcustomerButton();

            }

        })

    }

    // Initialize module
    $(function () {
        priv.init();
        authSubcustomerButton();
        selectPageSubcustomers();
    });

})();
